export const fontFamily = 'Verdana, monospace';
export const bodyFontFamily = '"Helvetica Neue", Menlo, monospace';
export const monoFontFamily = 'Menlo, monospace';
export const funnyFontFamily = '"Comic Sans MS", monospace';
